module.exports = __webpack_public_path__ + "img/video@2x.a01fa86f.png";